<ng-container *ngIf="upcoming?.length && totalUpcomingLoadedEventsCount > 0">
    <ms-heading class="section-heading" [title]="sitecore.event.Upcoming" />
    <div class="grid-wrapper" *ngFor="let upcomingGrid of upcoming">
        <ng-container *ngIf="upcomingGrid.grid | async as gridModel">
            <ng-container *ngIf="getLoadedEventsCountForGrid(gridModel) > 0">
                <ng-container
                    msScrolledToBottom
                    toleranceType="relative"
                    scrollContext="document"
                    *ngIf="loadOnScroll"
                    [toleranceValue]="0.5"
                    (scrollAtBottom)="getMoreUpcoming(upcomingGrid)" />
                <ms-grid [model]="gridModel" [tracking]="tracking" />
                <ng-container *ngIf="upcomingGrid.loading">
                    <div class="grid-footer ms-active-highlight" style="height: auto" *ngFor="let i of [0, 1, 2, 3]">
                        <div style="height: 20vh" class="spinner-img"></div>
                    </div>
                </ng-container>
                <div class="grid-footer ms-active-highlight" *ngIf="upcomingGrid.more" (click)="getMoreUpcoming(upcomingGrid)">
                    <div [class.spinner-img]="upcomingGrid.loading">{{ sitecore.event.MoreEvents }}</div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
<div class="spinner-img" *ngIf="loading"></div>
